export const getCookieDomain = ({ location } = typeof window !== 'undefined'
    ? window
    : { location: undefined }) => {
    if (!location) {
        return undefined;
    }
    return location.host.replace(/^(www|fr)/, '');
};
export const getCookie = (name, cookies) => {
    let documentCookies = '';
    if (!cookies && typeof window !== 'undefined') {
        documentCookies = document ? document.cookie : '';
    }
    const pairs = (cookies || documentCookies).split(';');
    const found = pairs
        .map(pair => pair.replace(/^[ ]+/, '').replace(/[ ]$/, ''))
        .map(pair => pair.split('='))
        .find(pair => pair[0] === name);
    return found ? decodeURIComponent(found[1]) : undefined;
};
// TODO: we can have a package for cookie
export const setCookie = (name, value, expires = '', path = '/') => {
    if (expires) {
        expires = `expires=${expires}`;
    }
    document.cookie = `${name}=${value};${expires};path=${path}`;
};
//# sourceMappingURL=cookies.js.map